"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fp = require("lodash/fp");
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 *
 * @param {Array} portableTexts - Array of portable text objects to join.
 * @param {string} delimiter - String to delimit the values when joining. Defaults to ' '.
 *
 * @returns {object} - A portable text object with type 'block', and value containing joined portable texts.
 */
var joinPortableText = function joinPortableText(portableTexts, delimiter) {
  var spacer = {
    type: 'span',
    value: delimiter || ' '
  };
  return {
    type: 'block',
    value: _lodash["default"].flatMap(portableTexts, function (portableText, index, array) {
      // If the portable text object passed in is a parent, join its children. Otherwise, join the object itself.
      var portableTextToJoin = (0, _fp.isObject)(portableText.value) ? portableText.value : portableText;
      return (0, _fp.size)(array) - 1 !== index ? (0, _fp.concat)(portableTextToJoin, spacer) : portableTextToJoin;
    })
  };
};
var _default = exports["default"] = joinPortableText;
module.exports = exports.default;